
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import GalleryPage from '../pages/gallery/page';
import AdminPage from '../pages/admin/page';
import AdminOrdersPage from '../pages/admin-orders/page';
import AdminAccess from '../pages/admin-access/page';
import NotFoundPage from '../pages/NotFound';
import ReturnPolicy from '../pages/return-policy/page';
import SecureShopping from '../pages/secure-shopping/page';
import PrivacyPolicy from '../pages/privacy-policy/page';
import FavoritesPage from '../pages/favorites/page';
import TermsOfServicePage from '../pages/terms-of-service/page';
import CheckoutPage from '../pages/checkout/page';
import OrderTrackingPage from '../pages/order-tracking/page';
import LoginPage from '../pages/login/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/gallery',
    element: <GalleryPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/noxsanat/admin',
    element: <AdminPage />
  },
  {
    path: '/admin-orders',
    element: <AdminOrdersPage />
  },
  {
    path: '/nox-admin-2024',
    element: <AdminAccess />
  },
  {
    path: '/order-tracking',
    element: <OrderTrackingPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  },
  {
    path: '/return-policy',
    element: <ReturnPolicy />
  },
  {
    path: '/secure-shopping',
    element: <SecureShopping />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: '/favorites',
    element: <FavoritesPage />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  }
];

export default routes;
